import Tooltip from 'primevue/tooltip'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  // PrimeVue Tooltip directive has incompatible TS types across transitive Vue versions.
  // Runtime is correct; suppress the type error at this call site.
  // @ts-expect-error PrimeVue tooltip type incompatibility (Vue minor version mismatch)
  nuxtApp.vueApp.directive('tooltip', Tooltip)
})
